import { Component, OnInit } from '@angular/core';
import { LoginRegisterService } from '../login-register/login-register.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

  public menuItems: Array<any>;
  public selectedIndex: number = null;
  isAdmin: boolean;

  constructor(
    private loginRegisterService: LoginRegisterService
  ) { }

  ngOnInit() {
    this.menuItems = [
      { id: 1, name: 'Home', icon: 'home_outline', link: '/dashboard/home' },
      { id: 2, name: 'Assessments', icon: 'assessment_outlined', link: '/dashboard/assessments', admin: false },
      { id: 3, name: 'Questions', icon: 'question_answer', link: '/dashboard/questions' },
      { id: 4, name: 'Best Practices', icon: 'assignment_turned_in', link: '/dashboard/bestpractice' },
      { id: 5, name: 'Settings', icon: 'settings', link: '/dashboard/settings', admin: false }
    ];

    this.loginRegisterService.currentUser.subscribe(res => {
      this.menuItems.map(item => {
        if (item.hasOwnProperty('admin')) {
          this.isAdmin = item.admin = (res?.role === 'ADMIN');
        }
        return item;
      });
    });

  }

  setIndex(index: number) {
    this.selectedIndex = index;
  }

}
